export default __webpack_public_path__ + "assets/pin-stroke-component.d8f4fe32.svg";